
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./react-apollo-0-introduction.json") })
        }
      }, "path---react-apollo-0-introduction");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---react-apollo-0-introduction!./.cache/json/react-apollo-0-introduction.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---react-apollo-0-introduction!./.cache/json/react-apollo-0-introduction.json
// module chunks = 154